import { render, staticRenderFns } from "./wechatListForm.vue?vue&type=template&id=bf5b5d06&scoped=true"
import script from "./wechatListForm.vue?vue&type=script&lang=js"
export * from "./wechatListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5b5d06",
  null
  
)

export default component.exports